module.exports = __webpack_public_path__ + "static/media/SDG13.d0ac0566.mp4";